// What changed between the list the television was last sent and the list now.
export const songListDelta = (previous: string[], next: string[]) => ({
  added: next.filter((id) => !previous.includes(id)),
  deleted: previous.filter((id) => !next.includes(id)),
});
